import {
  IStorageApplicationRoleConfigResponse,
  IShardRepositoryDeviceTokenV2ExportResponse,
} from "./bzs-config";
import { IShardRepositoryDeployRequest } from "./shard-repository";

export interface IDeploymentJobCreateRequest {
  applicationId: string;
  storagePoolId: string;
  label: string;
  region: string;
  vendor: K8Vendor;
  sbConfig: IClusterDeploymentSbConfig[];
  nbConfig: IStorageApplicationRoleConfigResponse;
}

export interface IClusterDeploymentSbConfig {
  id: string;
  data: IShardRepositoryDeviceTokenV2ExportResponse;
}

export enum K8Vendor {
  Linode = "linode",
}

export interface IStoragePoolConfig {
  id?: string;
  name?: string;

  ContentSecurityLevel: number;
  KeySecurityLevel: number;
  MetaSecurityLevel: number;

  contentStorages: Array<
    IShardRepositoryDeviceTokenV2ExportResponse | IShardRepositoryDeployRequest
  >;

  keyStorages: Array<
    IShardRepositoryDeviceTokenV2ExportResponse | IShardRepositoryDeployRequest
  >;

  metaStorages: Array<
    IShardRepositoryDeviceTokenV2ExportResponse | IShardRepositoryDeployRequest
  >;
}

export interface IBucketV2DeploymentRequest {
  name: string;
  storagePoolConfig: IStoragePoolConfig;
  enableObjectLock: boolean;
}
